import User from 'uscc-services/lib/model/User';
import Loading from 'components/ui/Loading';
import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { IconButton, InputAdornment, FormGroup, Toolbar, Button, AppBar, Dialog, Icon, Slide, Menu, MenuItem } from '@material-ui/core';
// import { TransitionProps } from '@material-ui/core/transitions';
import ValidationEvent from 'components/ui/form/ValidationEvent';
import ValidatedTextField from 'components/ui/form/ValidatedTextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { bus } from '../../events/EventBus';
import { Events } from '../../events/Events';
import UserIcon from '@material-ui/icons/Person';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { getUserInfo, getGroups, getAuthHeader, getCognitoUserInfo } from '../../auth'
import { AccountCircle } from '@material-ui/icons';

const axios = require('axios').default;
const { api, apiKey, authEndpoint } = require('../../../config')
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    alignMiddle: {
      verticalAlign: 'sub'
    },
    loginPaper: {
      padding: '2em'
    },
    loginContainer: {
      float: 'left',
      color: '#ffffff',
    },
    button: { padding: '10px 20px' },
    buttonIcon: { marginRight: '0.33em' },
    dialog: {
      position: 'absolute',
      top: '25%'
    },
    iconButton: {
      padding: '0 .33em',
      color: '#FFFFFF'
    },
    login: {
      color: '#ffffff',
    },
    loginInput: {
      color: '#ffffff',
      width: '10em',
      border: '1px solid #ffffff',
      margin: '0 !important',
      fontSize: '90% !important',
      backgroundColor: '#efefef'
    },
    menu: {
      backgroundColor: theme.palette.primary.dark
    },
    paper: {
      border: '1px solid',
      padding: theme.spacing(1),
      // backgroundColor: theme.palette.background.paper,
    },
    root: {
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '1200px',
      margin: '0 auto'
    },
    squareTop: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    rightMenu: {
      position: 'absolute',
      // top: '1em',
      right: '0em'
    }
  }),
);

export interface LoginForm {
  username: string,
  password: string
}

export class LoginFormImpl implements LoginForm {
  username: string = ''
  password: string = ''
}


// const Transition = React.forwardRef(function Transition(
//   props: TransitionProps & { children?: React.ReactElement<any, any> },
//   ref: React.Ref<unknown>,
// ) {
//   return <Slide direction="down" ref={ref} {...props} />;
// });  

export default function ButtonAppBar(props: any) {
  const userGroups = getGroups()
  const userInfo = getUserInfo()
  const cognitoUserInfo = getCognitoUserInfo()

  const classes = useStyles();
  const [form, setForm] = useState<LoginForm>(new LoginFormImpl());
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [user, setUser] = useState<User>(userInfo);
  const [isLoginModalVisible, setIsLoginModalVisible] = useState<boolean>(false);
  const [isLoginLoading, setIsLoginLoading] = useState<boolean>(false);
  const [validations, setValidations] = useState<any>({
    username: true,
    password: true
  });
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  let afterValidate = (event: ValidationEvent<HTMLInputElement>) => {
    setValidations({
      ...validations,
      [event.target.name]: event.isValid
    });
  }
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  let onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value: any = event.target.value;
    switch (event.target.name) {
      case 'subscribeToNewsLetter':
        value = event.target.checked;
        break;
    }
    setForm({
      ...form,
      [event.target.name]: value
    });
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const login = async () => {
    // setIsLoginLoading(true);
    // await axios({
    //   method: 'POST',
    //   url: `${api.users}/authenticate`,
    //   data: form,
    //   headers: {
    //     'x-api-key': apiKey
    //   }
    // })
    // .then((response: any) => {
    //   setIsLoginLoading(false);
    //   if(response.data) {
    //     let user: User = response.data;
    //     localStorage.setItem('user', JSON.stringify(user));
    //     setUser(user);
    //     setIsLoginModalVisible(false);
    //     form.username = "";
    //     form.password = "";
    //     setForm(form);
    //     bus.emit(Events.onAlert, {
    //       severity: "success",
    //       message: `Welcome ${user.firstName}!`,
    //       duration: 3000
    //     });
    //   } else {
    //     console.log('credentials did not match...');
    //   }
    // })
    // .catch((err: Error) => {
    //   console.log('error: ', err);
    // });
  }
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={'primary-search-account-menu'}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Link to="/profile"><MenuItem onClick={handleMenuClose}>Profile</MenuItem></Link>
      <a onClick={handleMenuClose} href={`${authEndpoint}/reset-password`}> <MenuItem>Reset Password</MenuItem></a>
    </Menu>
  );
  const logout = () => {
    // setUser(undefined);
    localStorage.removeItem('user');
    bus.emit(Events.onAlert, {
      severity: "success",
      message: "Logged out",
      duration: 3000
    });
  }

  return (
    <div className={classes.root}>
      <AppBar position="sticky" elevation={0} className={classes.menu}>
        <Toolbar>
          {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton> */}
          {!user &&
            <span>
              <a href={`${authEndpoint}/login`}>
                <Button
                  aria-label="Login"
                  aria-haspopup="false"
                  color="primary"
                  variant="text"
                  onClick={login}>
                  Login
                </Button>
              </a>
                |
                <a href={`${authEndpoint}/signup`}>
                <Button aria-label="Register" aria-haspopup="false" color="primary" variant="text">
                  Register
                  </Button>
              </a>
            </span>
          }
          {userGroups.filter(el => ['admin', 'searcher'].includes(el)).length > 0 && <div>
            <Link to="/search">
              <Button aria-haspopup="false" className={classes.menuButton} color="primary" variant="text">
                Search
              </Button>
            </Link>
          </div>}



          <div className={classes.rightMenu}>
            {user &&
              <span style={{ display: 'flex', alignItems: 'center', marginTop: '-10' }}>
                <Typography display="inline" className={classes.alignMiddle}>{`${cognitoUserInfo && cognitoUserInfo.email}`}</Typography>
                <MenuItem onClick={handleProfileMenuOpen}>
                  <IconButton
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                  >
                    <AccountCircle />
                  </IconButton>
                </MenuItem>
                {renderMenu}

                <a href={`${authEndpoint}/logout`}>
                  <Button
                    aria-label="Logout"
                    aria-haspopup="false"
                    color="primary"
                    variant="text">
                    Logout
                  </Button>
                </a>
              </span>
            }
            <Link to="/about">
              <Button aria-haspopup="false" className={classes.menuButton} color="primary" variant="text" aria-label="Home">
                About
            </Button>
            </Link>
            <Link to="/contact-us">
              <Button aria-haspopup="false" className={classes.menuButton} color="primary" variant="text">
                Contact
            </Button>
            </Link>
            {isLoginModalVisible &&
              <Dialog
                // TransitionComponent={Transition}
                open={isLoginModalVisible}
                onClose={() => { setIsLoginModalVisible(false) }}>
                <Loading isLoading={isLoginLoading} />
                <FormGroup className={classes.loginPaper}>
                  <Typography variant="h5" align="center">Login</Typography>
                  <ValidatedTextField
                    required
                    name="username"
                    label="Username"
                    aria-label="username"
                    value={form.username}
                    onChange={onChange}
                    afterValidate={afterValidate}
                  />

                  <ValidatedTextField
                    required
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    label="Password"
                    aria-label="Password"
                    value={form.password}
                    onChange={onChange}
                    afterValidate={afterValidate}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            edge="start"
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormGroup>
                <Button
                  variant="contained"
                  color="primary"
                  aria-label="Login"
                  className={clsx(classes.button, classes.squareTop)}
                  onClick={async () => { await login(); }}
                >
                  <Icon className={clsx(classes.buttonIcon, 'fa fa-sign-in-alt')} />
                    Login
                  </Button>
              </Dialog>
            }
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
